import isString from 'lodash/isString';

function removeSourcesIfPossible(map, sourcesToCheck) {
    const style = map.getStyle();
    const layers = style.layers ? style.layers : [];
    for (const source in sourcesToCheck) {
        if (Object.prototype.hasOwnProperty.call(sourcesToCheck, source)) {
            const hasLayerWithGivenSource = layers.some((layer) => layer.source === source);
            if (!hasLayerWithGivenSource) {
                map.removeSource(source);
            }
        }
    }
}

export default (map, tier) => {
    if (!tier) {
        return;
    }
    const sourcesToCheck = {};

    const style = tier.getStyle();

    if (!style || isString(style)) {
        return;
    }

    const layers = style.layers;
    layers.forEach((layer) => {
        map.removeLayer(layer.id);
        if (layer.source) {
            sourcesToCheck[layer.source] = layer.source;
        }
    });

    removeSourcesIfPossible(map, sourcesToCheck);
};



// WEBPACK FOOTER //
// ./map/tier/styleUpdate/removeTier.js